import styled from 'styled-components';

interface IProps {
	fullWidth?: boolean;
	fluid?: boolean;
	fluidOnSmallScreens?: boolean;
}

export default styled.div<IProps>`
	max-width: ${(props) => (props.fullWidth ? '100%' : props.fluid ? '1440px' : '1180px')};
	flex-grow: 1;
	margin: 0 auto;

	${(props) =>
		!props.fluid &&
		`
	@media screen and (max-width: 1220px) {
		margin: ${props.fluidOnSmallScreens ? '0' : '0 10px'};
	}
	`}
`;
